import {
	helpCenterTrainingIntro,
	helpCenterTrainingSections,
} from "../data/helpCenterTraining";

const HelpCenterTraining = () => (
	<div className="help-center__content-block">
		<p className="help-center__page-intro fs-13 ff-light">
			{helpCenterTrainingIntro}
		</p>
		{helpCenterTrainingSections.map((section) => (
			<section key={section.id} className="help-center__subsection">
				{section.title && (
					<h3 className="help-center__subsection-title ff-medium fs-14">
						{section.title}
					</h3>
				)}
				{section.links && (
					<ul className="help-center__link-list fs-13">
						{section.links.map((link) => (
							<li key={link.href}>
								<a
									href={link.href}
									target="_blank"
									rel="noopener noreferrer"
									className="text-quat-de"
								>
									{link.label}
								</a>
							</li>
						))}
					</ul>
				)}
			</section>
		))}
	</div>
);

export default HelpCenterTraining;
